<template>
    <v-container fluid>
        <v-card
            class="mx-auto"
            max-width="400"
        >
            <v-card-title
                class="primary--text secondary"
            >
                Employee Attendance Reports
            </v-card-title>

             <v-list>                
                <v-list-item-group color="primary">
                    <div v-for="(report, i) in reports" :key="i">
                        <v-list-item                            
                            @click="displayReportMenu(report)"
                        >
                            <v-list-item-content>
                                <v-list-item-title >
                                    {{ report.title}}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider
                            v-if="i < reports.length - 1"
                            :key="i"
                        >                        
                        </v-divider>
                    </div>
                    
                </v-list-item-group>
            </v-list>
            
        </v-card>

        <v-dialog
            v-model="dialog"
            max-width="90vw"
            persistent            
        >
            <v-card height="85vh" class="pb-0">
                <iframe 
                    ref="pdf" 
                    style="width:100%; height:100%" 
                    frameBorder="0" 
                    :src="src"
                ></iframe>

                <v-btn
                    dark
                    color="error"
                    small
                    fab
                    style="position:absolute; top:10px; right:10px; z-index:100"
                    @click="closeReportMenu"
                >
                    <v-icon dark>mdi-close</v-icon>
                </v-btn>
                
                <v-overlay
                    :absolute="absolute"
                    :value="overlay"
                    opacity="0.5"
                    color="#A0A0A0"
                >                
                    <v-card                        
                        light
                        :max-width="maxWidth"
                        class="pa-4"
                    >
                        <v-card-title class="">
                            {{ cardTitle }}
                        </v-card-title>


                        <v-card-text
                            v-if="menu.dailyAttendance" 
                        >
                             <v-row>
                               
                                <v-col cols="12" >                                   
                                    <v-radio-group v-model="radioGroup" row>
                                        <v-radio label="Teacher" value="teacher"></v-radio>
                                        <v-radio label="Auxillary Staff" value="auxillary"></v-radio>
                                    </v-radio-group>
                                </v-col>

                                <v-col
                                    cols="12"
                                >

                                    <v-date-picker
                                        v-model="picker"
                                        :allowed-dates="isAllowedDate"
                                    ></v-date-picker>
                                   
                                </v-col>
                            </v-row>  
                        </v-card-text>

                        <v-card-text
                            v-if="menu.individualAttendance" 
                        >
                             <v-row>
                               
                                <v-col cols="12" >                                   
                                    <v-radio-group v-model="radioGroup" row dense hide-details>
                                        <v-radio label="Teacher" value="teacher"></v-radio>
                                        <v-radio label="Auxillary Staff" value="auxillary"></v-radio>
                                    </v-radio-group>
                                </v-col>

                                <v-col cols="12">
                                    <v-autocomplete
                                        v-model="selectedEmployee"
                                        :items="employees"
                                        chips
                                        item-text="name"
                                        item-value="staff_id"
                                        dense
                                        hide-details
                                        outlined
                                    ></v-autocomplete>
                                </v-col>

                                <v-col
                                    cols="12" class="d-flex justify-center"
                                >
                                    <v-date-picker
                                        v-model="attendanceDates"
                                        range
                                        :allowed-dates="isAllowedDate"
                                    ></v-date-picker>
                                   
                                </v-col>
                            </v-row>  
                        </v-card-text>

                        <v-card-actions 
                            class="py-0"                            
                        >
                            <v-btn
                                color="primary"
                                dark
                                @click="displayReport"
                                :block="blockButton"
                                class="ml-auto"
                            >
                                Display Report
                            </v-btn>
                        </v-card-actions>

                         <v-overlay
                            :absolute="absolute"
                            :value="overlayLoading"                    
                            color="grey lighten-5"
                            opacity="0.9"
                            class="pa-5"
                        > 
                            <v-progress-circular
                                indeterminate 
                                size="64"                            
                                color="primary"                                
                            ></v-progress-circular>                   
                        </v-overlay>

                        <v-snackbar
                            v-model="snackbar.show"
                            :color="snackbar.color"
                            timeout="2000"
                        >
                            {{ snackbar.text}}
                            <template
                                v-slot:action="{ attrs }"
                            >
                                <v-btn color="white" text v-bind="attrs" @click="snackbar.show = false">Close</v-btn>
                            </template>
                        </v-snackbar>
                    </v-card>

                </v-overlay>                             
            </v-card>

            <v-container
                fluid
                class="pa-0"
                v-if="!overlay"
            >
                <v-sheet>
                    <v-row
                        justify="end"
                        class="ma-0"
                    >
                        <v-btn
                            color="primary"
                            small
                            dark
                            @click="closeReport"
                            class="my-2 mr-4"
                        >
                            Close
                        </v-btn>
                    </v-row>
                </v-sheet>
            </v-container>
           
        </v-dialog>
    </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
    components: {
    },

    mounted: function () {
        this.initialize();
    },
  
    data: () => ({
        reports: [
            {id: 1, title: "Daily Attendance Summary", value: 'dailyAttendance', menu: true},
            {id: 2, title: "Individual Employee Attendance", value: 'individualAttendance', menu: true},
        ],
        dialog: false,
        src: '',
        absolute: true,
        overlay: false,
        overlayLoading: false,
        cardTitle: '',        
        selectedReport: null,
        menu: {},        
        snackbar: {
            show: false,
            color: null,
            text: null,
        },
        maxWidth: 380,
        blockButton: false,
        selectedStaffType: null,
        staffTypes: [
            {id: 1, title: 'Teaching Staff', value: 'teaching'},
            {id: 2, title: 'Auxillary Staff', value: 'auxillary'},
        ],
        selectedDate: null,
        menuDate: false,
        radioGroup: "teacher",
        picker: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        selectedEmployee: null,
        teachers: [],
        auxillaryStaff: [],
        attendanceDates: [],
        allowedDatesTeacher: [],
        allowedDatesAuxillary: [],
    }),

    computed: {
        ...mapGetters({
            //
        }),

        employees () {
            if(this.radioGroup == 'teacher') return this.teachers;
            else if(this.radioGroup == 'auxillary') return this.auxillaryStaff;
            else return [];
        },
    },

    watch: {
       //
    },

    methods: {
        ...mapActions({
            getEmployees: 'attendanceEmployee/getEmployees',
            getAllowedDates: 'admin/getAllowedDates',
        }),

        ...mapMutations({
            //
        }),

        async initialize () {
           try {
                const [
                    { data: dataEmployees },
                    { data: dataAllowedDates }
                ] = await Promise.all([
                    this.getEmployees(), 
                    this.getAllowedDates()
                ]);

                const { auxillary, teachers } = dataEmployees;
                this.teachers = teachers;
                this.auxillaryStaff = auxillary;

                this.allowedDatesTeacher = dataAllowedDates.teacher;
                this.allowedDatesAuxillary = dataAllowedDates.auxillary;
                
           } catch (error) {
            error.response ? console.log(error.response) : console.log(error);
           }
        },

        
        clearMenu () {
            Object.keys(this.menu).forEach(key => {
                this.menu[key] = false;
            })
        },

        displayReportMenu (report) {
            this.overlay = true;
            this.maxWidth = 380;
            this.blockButton = true;
           
            this.selectedReport = report;
           
            this.reports.forEach(item => {  
                this.menu[item.value] = false;              
                if(item.value == report.value){
                    if(item.menu){
                        this.cardTitle = item.title;
                        this.menu[item.value] = true;
                    }                   
                }
            })

            this.dialog = true;           
        },

        displayReport () {
            this.overlay = true;
            const baseUrl = process.env.VUE_APP_API_URI  + '/api/';
            let startDate = null;
            let endDate = null;
            if(this.attendanceDates.length == 1){
                startDate = this.attendanceDates[0];
                endDate = this.attendanceDates[0];
            }
            else if(this.attendanceDates.length == 2){
                startDate = this.attendanceDates[0];
                endDate = this.attendanceDates[1];
            }
            console.log('selected employee', this.selectedEmployee);
            switch (this.selectedReport.value) {
                case "dailyAttendance":
                    if(this.radioGroup == 'teacher') 
                    this.src = `${baseUrl}employee-attendance-report/date/teacher?attendance_date=${this.picker}`;
                    else if(this.radioGroup == 'auxillary')
                    this.src = `${baseUrl}employee-attendance-report/date/auxillary?attendance_date=${this.picker}`;
                    break;                   
                case "individualAttendance":
                    if(this.attendanceDates.length == 0 || this.selectedEmployee == null){
                        this.snackbar.text = 'Please select an employee and attendance dates';
                        this.snackbar.color = 'red';
                        this.snackbar.show = true;
                        return;
                    } 
                    if(this.radioGroup == 'teacher'){
                        this.src = `${baseUrl}employee-attendance-report/teacher?start_date=${startDate}&end_date=${endDate}&teacher_num=${this.selectedEmployee}`;
                    }
                    else if(this.radioGroup == 'auxillary'){
                        this.src = `${baseUrl}employee-attendance-report/auxillary?start_date=${startDate}&end_date=${endDate}&employee_number=${this.selectedEmployee}`;
                    }
                    break;
            }
            console.log(this.src);
            this.overlay = false;
        },

        addParamsToUrl(url, params) {
            const urlObj = new URL(url);
            Object.keys(params).forEach(key => {
                if(params[key] !== undefined && params[key] !== null && params[key] !== '' && params[key] !== 0) {
                    urlObj.searchParams.append(key, params[key]);
                }
            });
            return urlObj.toString();
        },

        closeReportMenu () {
            this.dialog = false;
            this.src = '';
            this.selectedReport = null;
            this.selectedSubjectId = null;
            this.selectedFormLevel = null;
            this.clearMenu();
        },

        closeReport () {
            if(this.selectedReport.menu){
                this.overlay = true; 
                this.src = '';
            }
            else this.closeReportMenu();
        },

        isAllowedDate(date){
            if(this.radioGroup == 'teacher') return this.allowedDatesTeacher.includes(date);
            return this.allowedDatesAuxillary.includes(date);
        }
        
    }
}
</script>

